module.exports = __webpack_public_path__ + "img/08_DSC7895.9634dc58.jpg";